/**
 * HM-391/392/394 cluster 17 Planning Gantt: client API.
 */
import { api } from './client.js';

export type PlanningItem = {
  id: string;
  publicCode: string;
  roomId: string | null;
  roomCode: string | null;
  roomTypeId: string | null;
  guestId: string | null;
  guestName: string | null;
  service: 'day_use' | 'overnight';
  status:
    | 'pending'
    | 'confirmed'
    | 'checked_in'
    | 'checked_out'
    | 'cancelled'
    | 'no_show'
    | 'conflict_unresolved';
  channel: 'walk_in' | 'phone' | 'online' | 'ota';
  startAt: string; // ISO
  endAt: string; // ISO
  extraHours: number;
  totalAmount: string;
  extraAmount: string;
  paidAmount: string;
  checkedInAt: string | null;
  checkedOutAt: string | null;
};

export async function listPlanningRange(
  fromIso: string,
  toIso: string,
  hotelId?: string,
): Promise<{ items: PlanningItem[]; truncated: boolean }> {
  const qs = new URLSearchParams({ from: fromIso, to: toIso });
  if (hotelId) qs.set('hotelId', hotelId);
  return api(`/planning/range?${qs.toString()}`, { method: 'GET' });
}

export type PlanningStats = {
  date: string;
  roomsTotal: number;
  roomsOccupied: number;
  occupancyPct: number;
  checkInsToday: number;
  checkOutsToday: number;
  revenueToday: number;
  anomalies: { lateCheckouts: number; extraHoursActive: number };
};

export async function getPlanningStats(date: string, hotelId?: string): Promise<PlanningStats> {
  const qs = new URLSearchParams({ date });
  if (hotelId) qs.set('hotelId', hotelId);
  return api(`/planning/stats?${qs.toString()}`, { method: 'GET' });
}

export type RescheduleResult = {
  ok: true;
  noop: boolean;
  booking: PlanningItem;
};

export async function rescheduleBooking(
  bookingId: string,
  input: { newRoomId: string; newStartAt: string; newEndAt: string; reason?: string },
): Promise<RescheduleResult> {
  return api(`/bookings/${bookingId}/reschedule`, {
    method: 'PATCH',
    body: JSON.stringify(input),
  });
}

// HM-411 cluster 17.2 polish: admin-only cancel con motivo obbligatorio (min 5).
export type AdminCancelResult = {
  booking: PlanningItem;
};

export async function adminCancelBooking(
  bookingId: string,
  reason: string,
): Promise<AdminCancelResult> {
  return api(`/bookings/${bookingId}/admin-cancel`, {
    method: 'POST',
    body: JSON.stringify({ reason }),
  });
}
